import {Feature} from "../../../core/gd/access-control/feature-access/const"
import {featureAccess} from "../../../core/gd/access-control/feature-access/feature-access"

export default function taskView_checkTimeReportAccess(): boolean {
    if (!featureAccess(Feature.TIME_TRACKING)) {
        gd.modals.other.upgrade(Feature.TIME_TRACKING)
        return false
    }
    return true
}
